document.addEventListener('DOMContentLoaded', function () {
  const productMain = document.querySelector('main.product-page');
  if (!productMain) return;

  const galleryWrapper = document.querySelector('.woocommerce-product-gallery__wrapper');
  if (!galleryWrapper) return;

  const images = galleryWrapper.querySelectorAll('.woocommerce-product-gallery__image');
  const mainImageLink = images[0]?.querySelector('a');
  const mainImagePicture = mainImageLink?.querySelector('picture');
  const mainImage = mainImagePicture?.querySelector('img');
  const mainSource = mainImagePicture?.querySelector('source[type="image/webp"]');

  if (!mainImage) return;

  // Remove lightbox and links
  images.forEach((item) => {
    const link = item.querySelector('a');
    if (link) {
      link.removeAttribute('href');
      link.removeEventListener('click', function (e) {
        e.preventDefault();
      });
    }
  });

  // Swap main image and source on thumbnail click
  images.forEach((item, index) => {
    if (index === 0) return;

    item.addEventListener('click', function (e) {
      e.preventDefault();
      console.log("clicked");

      const link = item.querySelector('a');
      const thumbPicture = link?.querySelector('picture');
      const thumbImg = thumbPicture?.querySelector('img');
      const thumbSource = thumbPicture?.querySelector('source[type="image/webp"]');

      if (!thumbImg) return;

      // Update <img>
      mainImage.src = thumbImg.getAttribute('data-large_image');
      mainImage.srcset = thumbImg.getAttribute('srcset');
      mainImage.alt = thumbImg.alt;

      // Update <source>
      if (mainSource && thumbSource) {
        mainSource.srcset = thumbSource.srcset;
      }

      mainImageLink?.removeAttribute('href');
    });
  });

  // Remove WooCommerce’s lightbox class
  images.forEach(item => {
    item.classList.remove('woocommerce-product-gallery__image--with-lightbox');
  });
});
